import { Box, Flex, Img, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import { particlesOptions } from "../config/particle.config";
import styles from "../styles/Hero.module.css";
import HeroContent from "./HeroContent";



const HeroImage = () => {
    
  const particlesInit = (engine) => {
    loadFull(engine);
  };

//   const [scrollPos, setScrollPos] = useState(0);

//   useEffect(() => {
//     function handleScroll() {
//       setScrollPos(window.pageYOffset);
//     }

//     window.addEventListener("scroll", handleScroll);

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);


  return (
    <Box id="home" h="90vh" className={styles.Hero__container} >
      <Particles init={particlesInit} options={particlesOptions} /> 
      <HeroContent />

    </Box>
  );
};

export default HeroImage;
